<template>
  <section>
    <v-dialog
      v-model="showModal"
      max-width="600px"
    >
      <v-card
        color="#ECEFF1"
      >
        <br>
        <h2 class="title-style">
          <v-icon class="icon-style">
            mdi-database-plus
          </v-icon> Add Partner API
        </h2>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="apiName"
                  label="Name*"
                  dense
                  outlined
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="methodType"
                  menu-props="auto"
                  :items="methodTypes"
                  item-value="id"
                  item-text="name"
                  label="Method*"
                  dense
                  outlined
                  single-line
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="uri"
                  dense
                  outlined
                  label="URI"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
          </v-form>
          <p class="text-sm-left">
            *Indicates required field
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="showModal = false;"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="#FF3700"
            @click="addNewPartnerApi()"
          >
            Add
          </v-btn>
        </v-card-actions>
        <br>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
    </v-dialog>
  </section>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'AddNewPartnerAPI',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        showModal: true,
        loading: false,
        methodTypes: [
          { name: 'POST', id: 'post' },
          { name: 'GET', id: 'get' },
          { name: 'PUT', id: 'put' },
          { name: 'DELETE', id: 'delete' },
        ],
        apiName: '',
        methodType: '',
        uri: '',
        valid: false,
      };
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      async addNewPartnerApi () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        const partnerId = this.$route.params.id;
        await this.$store.dispatch('partners/addNewPartnerApi', {
          apiDetails: {
            name: this.apiName,
            method: this.methodType,
            uri: this.uri,
          },
          partnerId: partnerId,
        })
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Partner API created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.loading = false;
            this.$emit('partner-api-success');
            this.showModal = false;
          }).catch(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
::v-deep .input-field-styling .v-label {
  font-weight: bolder;
  color: #37474F;
  font-size: 14px;
}
</style>
